enum FeeType {
  Fixed = 'FIXED',
  FixedMarkup = 'FIXED_MARKUP',
  Percent = 'PERCENT',
  Override = 'OVERRIDE',
}

export default FeeType;
